<template>
  <div class="sub-page">
    <VolleyballSelect :componentName="componentName" :playerList="playerList" @handleSelect="handleSelect" :total="total"/>
    <div class="main" v-if="playerList.length >0">
      <div class="row row-title">
        <div class="col-1">序号</div>
        <div class="col-2">代表队</div>
        <div class="col-3">运动员</div>
        <div class="col-4">号码</div>
        <div class="col-5">位置</div>
        <div class="col-6">性别</div>
        <div class="col-7">出生年月</div>
      </div>
      <div class="row" v-for="(item,index) in playerList" :key="index" :class="index%2==1?'active-bg':''">
        <div class="col-1">{{ index+1+(playerParams.pageNum-1)*playerParams.pageSize }}</div>
        <div class="col-2">{{item.agencyName}}</div>
        <div class="col-3">
          <img :src="item.head" alt="" />
          <div class="name">{{item.name}}</div>
        </div>
        <div class="col-4">{{ item.jerseyNumber }}</div>
        <div class="col-5">{{item.location}}</div>
        <div class="col-6">{{item.sex==1?'男':'女'}}</div>
        <div class="col-7">{{item.birthday.slice(0,10)}}</div>
      </div>
      <AntdvPagination :total="total" :pageSize="playerParams.pageSize" :pageNum="playerParams.pageNum" v-if="total>playerList.length" @changePageNum="changePageNum"/>
    </div>
    <AntdvEmpty v-else />
  </div>
</template>

<script>
import AntdvEmpty from '@comm/components/public/AntdvEmpty.vue'
import AntdvPagination from '@comm/components/public/AntdvPagination.vue'
import VolleyballSelect from './VolleyballSelect.vue'
export default {
  name: 'VolleyballPlayer',
  props: {
    // palyerList: {
    //   type: Array,
    //   default: () => [],
    // },
    componentName: {
      type: String,
      default: 'VolleyballPlayer',
    },
  },
  data() {
    return {
      tabIndex: 0,
      playerParams:{
        matchId:this.$route.query.matchId,
        agencyId:null,
        sex:-1,
        pageNum:1,
        pageSize:20,
      },
      playerList:[],
      total:0,
    }
  },
  components: { AntdvEmpty, VolleyballSelect,AntdvPagination },
  mounted() {
    this.getQueryBigballPlayer()
  },
  methods: {
    //分页
    changePageNum(pageNum){
      this.playerParams.pageNum=pageNum
      this.getQueryBigballPlayer()
    },
    //选择赛程
    handleSelect(item,index){
      //index:1为轮次，2为球队，3性别 
      switch(index){
        case 2:
          this.playerParams.agencyId=item
          break
        case 3:
          this.playerParams.sex=item
          break
      }
      this.getQueryBigballPlayer()
    },
    async getQueryBigballPlayer(){
      try {
           let res =await this.$api.district.queryBigballPlayer(this.playerParams)
           if(res.status ==0){
           this.playerList=res.data
           this.total=res.total
           }else{
           this.message.error(res.msg)
         }
      } catch (error) {
         console.log(error);
      }
    }
    
  },
  watch: {},
}
</script>

<style scoped lang="scss">
.sub-page {
  width: 100%;
  background-color: #f7f7f7;

  .bg {
    width: 100%;
    background-color: #f7f7f7;
    padding: 20px 0;
    .player-select {
      width: 1200px;
      margin: 0 auto;
      height: 70px;
      background-color: #ffffff;
      overflow: hidden;
      display: flex;
      justify-content: flex-start;
      flex-wrap: nowrap;
      align-items: center;
      padding: 0 30px;
      box-sizing: border-box;
      box-shadow: 0px 5px 8px rgba(0, 0, 0, 0.1);
      display: flex;
      justify-content: space-between;
      .left {
        display: flex;
        justify-content: flex-start;
      }
    }
  }
  .main {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 30px;
    .row {
      display: flex;
      font-size: 14px;
      justify-content: space-between;
      align-items: center;
      font-weight: bold;
      height: 60px;
      line-height: 60px;
      text-align: center;
      border-bottom: 1px solid #eeeeee;
      .col-1 {
        width: 10%;
        text-align: left;
        padding-left: 30px;
      }
      .col-2 {
        width: 20%;
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .col-3 {
        width: 20%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        .name {
          width: 80%;
          margin-left: 10px;
          box-sizing: border-box;
        }
        img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }
      }
      .col-4 {
        width: 10%;
      }
      .col-5 {
        width: 10%;
      }
      .col-6 {
        width: 10%;
      }
      .col-7 {
        width: 20%;
      }
    }
    .row-title {
      background-color: #313131;
      border-radius: 10px 10px 0 0;
      color: #fff;
      margin-top: 20px;
      font-size: 16px;
      font-weight: bold;
    }
    .active-bg{
      background-color: #E9E9E9;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/comm/components/match/volleyball/components/VolleyballPlayer.vue